import type { FieldTextProps } from "./field-text.type";

import { Form, Input } from "antd";

import { INPUT_MAX_LENGTH } from "@/constants/Fields";

export const FieldText = ({
  name,
  label,
  required,
  disabled,
  hidden,
  maxLength,
  onChange,
  placeholder,
  extra,
  suffix,
  className,
}: FieldTextProps) => {
  return (
    <Form.Item
      name={name}
      label={label}
      rules={required ? [{ required: true }] : undefined}
      required={required}
      hidden={hidden}
      extra={extra}
      className={className}
    >
      <Input
        showCount
        placeholder={placeholder}
        maxLength={maxLength ?? INPUT_MAX_LENGTH}
        disabled={disabled}
        onChange={onChange}
        suffix={suffix}
      />
    </Form.Item>
  );
};
